module.exports = __webpack_public_path__ + "static/media/appLab_multiplication.387af1ce.png";